export default class EventAddController {
    constructor($routeParams, $location, $window, eventService) {
        this.$location = $location;
        this.eventService = eventService;
        this.$routeParams = $routeParams;
        this.$window = $window;

        this.event = {
            clientId: $routeParams.clientId
        }
    }

    onSave() { 
        this.eventService.add(this.event).then(resp => {
            this.$location.path(`/manage/clients/edit/${this.$routeParams.clientId}`);
        });
    }

    goBack(){
        this.$window.history.back();
    }
}


// WEBPACK FOOTER //
// ./src/js/components/events/events.add.controller.js